import React, { ReactNode, useState } from "react";
import Modal from "components/Modal/modal";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import MDBox from "components/MDBox";

interface TabData {
  label: string;
  content: ReactNode;
  mode: string;
}

interface Props {
  stickyNavbar?: boolean;
  tabs: TabData[];
  children: ReactNode;
}

const Navigation = ({ stickyNavbar, tabs, children }: Props): JSX.Element => {
  const [tabValue, setTabValue] = useState<number>(0);
  const [modalState, setModalState] = useState<boolean>(false);
  const [renderedTabs, setRenderedTabs] = useState<{ [key: number]: boolean }>({
    0: true,
  });
  const [renderedModalsTabs, setRenderedModalsTabs] = useState<{
    [key: number]: boolean;
  }>({});

  const handleSetTabValue = (newValue: number) => {
    if (tabs[newValue]?.mode === "modal") {
      if (!renderedModalsTabs[newValue]) {
        setRenderedModalsTabs((prev) => ({ ...prev, [newValue]: true }));
      }
      setModalState(true);
    } else {
      setTabValue(newValue);
      if (!renderedTabs[newValue]) {
        setRenderedTabs((prev) => ({ ...prev, [newValue]: true }));
      }
    }
  };

  return (
    <MDBox mt={stickyNavbar ? 3 : 10}>
      <MDBox mb={2}>
        <Select
          value={tabValue}
          onChange={(e) => handleSetTabValue(Number(e.target.value))}
          fullWidth
          sx={{
            backgroundColor: "#fff",
            borderRadius: 2,
            fontWeight: 600,
            fontSize: 16,
            height: 48,
          }}
        >
          {tabs.map((tab, index) => (
            <MenuItem key={index} value={index}>
              {tab.label}
            </MenuItem>
          ))}
        </Select>
      </MDBox>
      <div>
        {tabs.map((tab, index) =>
          tab.mode === "inside" ? (
            <div
              key={index}
              style={{ display: tabValue === index ? "block" : "none" }}
            >
              {renderedTabs[index] && tab.content}
            </div>
          ) : (
            <Modal
              key={index}
              title={tab.label}
              openModal={modalState}
              body={<>{renderedModalsTabs[index] && tab.content}</>}
              handleAction={() => setModalState(!modalState)}
              action={true}
              actionLabel={"Fermer"}
              valid={false}
              handleClose={() => setModalState(!modalState)}
              cancel={false}
              fullScreen={true}
            />
          )
        )}
      </div>

      {children}
    </MDBox>
  );
};

// Declaring default props for Navigation
Navigation.defaultProps = {
  stickyNavbar: false,
};

export default Navigation;
